import sample_01 from './twinstarProtectSpecial.jpg';

export const twinstarProtectSpecialImpressions = {
    sample_01,
};
